import { render, staticRenderFns } from "./VendorAccount.vue?vue&type=template&id=11e85209&"
import script from "./VendorAccount.vue?vue&type=script&lang=js&"
export * from "./VendorAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11e85209')) {
      api.createRecord('11e85209', component.options)
    } else {
      api.reload('11e85209', component.options)
    }
    module.hot.accept("./VendorAccount.vue?vue&type=template&id=11e85209&", function () {
      api.rerender('11e85209', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/dashboard/practice-info/VendorAccount.vue"
export default component.exports